import type { MisconceptionDefinition } from './types'

/** GET — Getalbegrip misconcepties. */
export const GET_MISCONCEPTIONS: MisconceptionDefinition[] = [
  {
    id: 'get.place-value-swap',
    label: 'Plaatswaarde verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling verwisselt tientallen en eenheden, of honderdtallen en tientallen.',
    typicalFamilies: ['GET-GROOT-LEZEN', 'GET-GROOT-POS'],
  },
  {
    id: 'get.decimal-align',
    label: 'Komma niet uitgelijnd',
    module: 'Getalbegrip',
    description:
      'Leerling lijnt kommagetallen niet uit bij optellen/aftrekken.',
    typicalFamilies: ['GET-KOMMA-PLUS', 'GET-KOMMA-MIN'],
  },
  {
    id: 'get.fraction-whole-comparison',
    label: 'Breuk als geheel getal vergeleken',
    module: 'Getalbegrip',
    description:
      'Leerling vergelijkt teller en noemer apart i.p.v. de breukwaarde.',
    typicalFamilies: ['GET-BREUK-BASIS', 'GET-VERGELIJK'],
  },
  {
    id: 'get.percentage-of-vs-increase',
    label: 'Percentage van vs. toename',
    module: 'Getalbegrip',
    description:
      'Leerling verwart "X% van" met "X% toename" (bijv. 20% van 100 vs. 100 + 20%).',
    typicalFamilies: ['GET-PROC-VAN', 'GET-PROC-TOENAME'],
  },
  {
    id: 'get.negative-subtraction-direction',
    label: 'Negatief aftrekken omgedraaid',
    module: 'Getalbegrip',
    description:
      'Leerling draait de richting om bij aftrekken met negatieve getallen.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
]
